import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {Complaint} from "@/interfaces/entity";
import {PaginationMeta} from "@/interfaces/common";
import {ComplaintParams} from "@/modules/complaint/params";
import {ComplaintCustomerState} from "@/modules/complaintcustomer/state";
import {ComplaintCustomerParams} from "@/modules/complaintcustomer/params";
import {
    createComplaintCustomer,
    listComplaintCustomer,
    singleComplaintCustomer
} from "@/modules/complaintcustomer/service";

@Module({dynamic: true, name: "complaintCustomer", store})
class ComplaintCustomerModule extends VuexModule implements ComplaintCustomerState {
    data: IdMapper<Complaint> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: ComplaintCustomerParams = new ComplaintCustomerParams();

    @Mutation
    private UPDATE_COMPLAINT_CUSTOMER_PARAMS(payload: any) {
        this.params = payload
    }

    @Mutation
    private MAP_COMPLAINT_CUSTOMER(payload: any) {
        const idMapper: IdMapper<Complaint> = {};
        this.meta = payload.meta;
        this.ids = payload.datas.map((complaint: Complaint, index: any) => {
            idMapper[complaint.id] = {...complaint, isDeleting: false, stt: index + 1};
            return complaint.id;
        });
        this.data = idMapper;
    }

    @Mutation
    private ADD_COMPLAINT_CUSTOMER(payload: Complaint) {
        if (!payload || this.ids.includes(payload.id) || this.data[payload.id]) return;
        this.ids = [...this.ids, payload.id];
        this.data = {...this.data, [payload.id]: {...payload, isDeleting: false}}
    }

    @Mutation
    private UPDATE_COMPLAINT_CUSTOMER(payload: Complaint) {
        if(!this.data[payload.id] || !this.ids.includes(payload.id)) return;
        this.data[payload.id] = { ...payload, isDeleting: false}
    }

    @Action({rawError: true})
    public async createComplaintCustomer(form: any) {
        const { data } = await createComplaintCustomer(form);
        // this.ADD_COMPLAINT_CUSTOMER(data.data);
    }

    @Action( {rawError: true})
    public async listComplaintCustomer(params: ComplaintParams = new ComplaintParams()) {
        const { data } = await listComplaintCustomer(params);
        this.MAP_COMPLAINT_CUSTOMER(data);
    }

    @Action({rawError: true})
    public async singleComplaintCustomer(id: number) {
        const { data } = await singleComplaintCustomer(id);
        return data.data;
    }

    @Action
    public updateComplaintCustomerParams(payload: any) {
        this.UPDATE_COMPLAINT_CUSTOMER_PARAMS(payload)
    }
}
export const ComplaintCustomerStore = getModule(ComplaintCustomerModule)